/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".safe_host[_ngcontent-%COMP%]{background-color:#eee}.page_banner[_ngcontent-%COMP%]{background:url(/assets/images/portalapi.jpg) center center no-repeat #333;position:relative}.why_choose_hosting[_ngcontent-%COMP%]   .hosting_box[_ngcontent-%COMP%]:hover   i[_ngcontent-%COMP%]{background-color:#f8a841;color:#fff}\n/*# sourceMappingURL=portal-e-apis.component.css.map*/"];
export { styles as styles };
